import { render, staticRenderFns } from "./AccountHistoryOrgTabs.vue?vue&type=template&id=5d82ea72&"
import script from "./AccountHistoryOrgTabs.vue?vue&type=script&lang=js&"
export * from "./AccountHistoryOrgTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports